import React from "react";
import { useNavigate } from "react-router-dom";

const Navbar = ({ toggleSidebar, token, logout }) => {
  const navigate = useNavigate();

  return (
    <nav
      className="navbar bg-dark shadow-sm px-3 d-flex justify-content-between align-items-center"
      style={{
        borderBottom: "1px solid rgba(255,255,255,0.05)",
        height: "70px",
        direction: "rtl"
      }}
    >
      <div className="d-flex align-items-center gap-3">
        {/* زر التحكم بالجانبية */}
        <button
          className="btn btn-outline-info border-0 p-2 d-flex align-items-center justify-content-center"
          onClick={toggleSidebar}
          style={{ width: "40px", height: "40px", borderRadius: "10px" }}
        >
          <i className="bi bi-list fs-4"></i>
        </button>

        {/* الشعار والعنوان */}
        <div
          className="d-flex align-items-center gap-2"
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/admin/")}
        >
          <img
            src="/website-icon.png"
            alt="Logo"
            style={{ width: "35px", height: "auto" }}
          />
          <span className="text-white fw-bold mb-0 fs-5 d-none d-sm-inline">
            الادارة العامة لحماية المستهلك          </span>
        </div>
      </div>

      <div className="d-flex align-items-center gap-2">
        {token ? (
          <div className="d-flex align-items-center">
            {/* أيقونة تنبيهات أو بروفايل بسيطة (اختياري) */}
            <div className="text-white-50 ms-3 d-none d-md-block" style={{ fontSize: "0.85rem" }}>
              <i className="bi bi-person-circle me-1"></i> المسؤول
            </div>

            <button
              className="btn btn-danger btn-sm px-3 rounded-pill d-flex align-items-center gap-2"
              style={{ fontSize: "0.85rem", fontWeight: "600" }}
              onClick={() => {
                logout();
                navigate("/admin/login");
              }}
            >
              <i className="bi bi-box-arrow-left"></i>
              تسجيل الخروج
            </button>
          </div>
        ) : (
          <button
            className="btn btn-info btn-sm px-4 rounded-pill fw-bold"
            onClick={() => navigate("login")}
          >
            <i className="bi bi-person-lock me-1"></i>
            تسجيل الدخول
          </button>
        )}
      </div>

      <style>{`
        .navbar {
          z-index: 1050; /* أقل من الـ Sidebar بـ 50 درجة ليختفي تحته عند الإغلاق */
        }
        .btn-outline-info:hover {
          background-color: rgba(13, 202, 240, 0.1);
          color: #0dcaf0;
        }
      `}</style>
    </nav>
  );
};

export default Navbar;